<template>
  <div id="discover-kettle-college-tool" class="bootstrap-styles">
    <!-- Display one of three components depending on user state -->
    <Welcome v-if="!started && !finished" @started=start />
    <transition name="fade" mode="out-in" :duration="500">
      <Quiz v-if="started && !finished" @finished=finish v-bind:lists=lists />
      <Results v-if="finished" v-bind:lists=lists v-bind:user=user />
    </transition>
  </div>
</template>

<script>
import axios from 'axios'

import Welcome from './components/Welcome.vue'
import Quiz from './components/Quiz.vue'
import Results from './components/Results.vue'

import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

const DATA_PATH = process.env.VUE_APP_DATA_PATH || 'https://discover-roi.s3.amazonaws.com';

export default {
  name: 'App',
  data: function () {
    return {
      started: false, // whether user has started quiz
      finished: false, // whether user has finished quiz
      user: {}, // copy of user object; populated on quiz completion
      lists: { // school, career, degree data
        schools: [],
        degrees: [],
        careers: [],
        occupations: [],
        outcomes: {},
        degreesByCareer: new Map(),
        careersByDegree: new Map(),
      }
    }
  },
  components: {
    Welcome,
    Quiz,
    Results,
  },
  mounted: function() {
    var container = document.getElementById('discover-kettle-college-tool');
    
    // detect touch device
    if (!!('ontouchstart' in window) || !!('msmaxtouchpoints' in window.navigator)) {
      container.classList.add('touchevents');
    } else {
      container.classList.add('no-touchevents');
    }

    // Download remote data files
    axios.get(DATA_PATH + '/outcomes.json')
      .then((response) => {
        const outcomes = response.data;
        this.lists.outcomes = outcomes;
      });
    
    axios.get(DATA_PATH + '/schools.json')
      .then((response) => {
        const schools = response.data;
        schools.forEach((s) => s.label = `${s.INSTNM} (${s.STABBR})`); // add label value
        schools.sort((s1, s2) => s1.INSTNM.localeCompare(s2.INSTNM)); // alphabetize
        this.lists.schools = schools;
      });

    axios.get(DATA_PATH + '/careers.json')
      .then((response) => {
        this.lists.careers = response.data;

        // Create set of degrees
        const degrees = this.lists.careers.map((c) => c.degfieldd);
        degrees.sort(); // alphabetize

        const uniqueDegrees = [];
        let previousDegree = null;
        degrees.forEach(function(d){
          if (d !== previousDegree) {
            uniqueDegrees.push(d);
            previousDegree = d;
          }
        });
        uniqueDegrees.sort(); // alphabetize again, for Safari
        this.lists.degrees = uniqueDegrees;

        // Create mapping of degree to list of careers
        this.lists.careers.forEach((c) => {
          const careers = this.lists.careersByDegree.get(c.degfieldd) || [];
          careers.push(c);
          this.lists.careersByDegree.set(c.degfieldd, careers);
        });

        // Sort careersByDegree values by commonness
        this.lists.careersByDegree.forEach((careers) => {
          careers.sort((c1, c2) => c2.deg_frac - c1.deg_frac);
        });

        // Create mapping of career to list of degrees
        this.lists.careers.forEach((c) => {
          const degrees = this.lists.degreesByCareer.get(c.occ_code) || [];
          degrees.push(c);
          this.lists.degreesByCareer.set(c.occ_code, degrees);
        });

        // Sort careersByDegree values by commonness
        this.lists.degreesByCareer.forEach((degrees) => {
          degrees.sort((c1, c2) => c2.deg_frac - c1.deg_frac);
        });

        const occupations = this.lists.careers.map((c) => c.occ_code);
        occupations.sort(); // alphabetize
        const uniqueOccupations = [];
        let previousOccupation = null;
        occupations.forEach(function(o){
          if (o !== previousOccupation) {
            uniqueOccupations.push(o);
            previousOccupation = o;
          }
        });
        this.lists.occupations = uniqueOccupations;
      });
  },
  methods: {
    /**
     * Mark quiz as finished
     *
     * @param object user
     */
    finish: function (user) {
      this.finished = true;
      this.user = user;
    },
    /**
     * Mark quiz as started
     */
    start: function () {
      this.started = true;
    }
  }
}
</script>

<style lang="scss">
// Import custom SASS variable overrides, or alternatively
// define your variable overrides here instead
@import 'assets/custom-vars.scss';
@import 'assets/_mixins.scss';
@import 'assets/fonts.scss';
html {
  font-size: 10px;
}
body {
  background-color: #fafafa;
  margin: 0;
}
#discover-kettle-college-tool {
  @include text(16 22 null 500);
  margin-inline: auto;
  position: relative;
  color: $discover-midnight;
  -webkit-font-smoothing: antialiased;

  // Import Bootstrap and BootstrapVue source SCSS files
  @import '~bootstrap/scss/bootstrap.scss';
  @import '~bootstrap-vue/src/index.scss';
  // @import 'assets/_mixins.scss';
  @import 'assets/main.scss';
  @import '~swiper/swiper.scss';
  .row:before, .row:after {
    display: none;
  }
}
</style>
